module.exports = __webpack_public_path__ + "static/media/empty.1cace0d8.png";